// extracted by mini-css-extract-plugin
module.exports = {"container":"_25N77LPEA_TKoOoxIOLsex","flex":"rcwy-kZObjXnDVaOfIhpm","download":"RRGshJ6ECPc19XTRtlPsd","logo":"_2R-ZC9LeqhrFhsyHVO0yjH"};